const sanitizeQuery = query =>
	typeof query === 'string' && query.trim() !== '' && query !== 'null'
		? query
		: '';

export default sanitizeQuery;
